<div class="main main-full config-background-2">
    <div class="container h-100">
        <div class="row">
            <div class="col-12">
                <a href="https://makersplace.com/corridordigital/" class="btn btn-outline-primary">Makersplace</a>
            </div>
        </div>
    </div>
</div>
